import { useHistory } from 'react-router-dom';
import Button from '@Atoms/Button';
import { ArrowForward } from '@mui/icons-material';
import Box from '@Atoms/Box';
import ShowIf from '@Atoms/ShowIf';
import React from 'react';

interface MessageProps {
  testletId: number;
  sectionId: number;
  courseId: string;
  testSessionId: number;
  message: string;
  buttonText?: string;
}

const Message = ({
  testletId,
  sectionId,
  courseId,
  testSessionId,
  message,
  buttonText,
}: MessageProps) => {
  const history = useHistory();
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <p>{message}.</p>
      <ShowIf If={!!buttonText}>
        <Button
          variant="text"
          sx={{
            color: 'white',
            textTransform: 'none',
            '&:hover': { color: 'secondary.main' },
          }}
          endIcon={<ArrowForward />}
          onClick={() =>
            history.push(
              `/tests/course/${courseId}/section/${sectionId}/testsession/${testSessionId}/testlet/${testletId}`,
            )
          }
        >
          {buttonText}
        </Button>
      </ShowIf>
    </Box>
  );
};

export default Message;
